import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

import webScrapImage1 from '../assets/images/services/it/ENTRANCE MANAGEMENT.jpg';
import webScrapImage2 from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';
import webScrapImage3 from '../assets/images/services/it/CCTV1.jpg';
import webScrapImage4 from '../assets/images/services/it/INTRUSTION ALARMS.jpg';

import softwareVideo from '../assets/videos/software/scrapping.mp4';

import webScrapBenefitsImage from '../assets/images/software/web-scrapping.jpg';

const SoftwareWebScrappingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Web Scraping Solutions" description="Web scraping and data extraction services in DRC. Automated data collection and analysis solutions by Cool & Care." keywords="web scraping DRC, data extraction, automated data collection, data analysis Kinshasa" />
      <ServiceSchema name="Web Scraping Solutions" description="Web scraping, data extraction, and automated data collection services." url="/software-web-scrapping" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'Web Scraping', url: '/software-web-scrapping' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareWebScrapping.name')}
      serviceDescription={t('servicePage.services.softwareWebScrapping.description')}
      videoUrl={softwareVideo}
      productImages={[
        webScrapImage1,
        webScrapImage2,
        webScrapImage3,
        webScrapImage4
      ]}
      features={t('servicePage.services.softwareWebScrapping.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareWebScrapping.benefits', { returnObjects: true }) as string[]}
      benefitsImage={webScrapBenefitsImage}
    />
    </>
  );
};

export default SoftwareWebScrappingPage;

